import React from 'react';
import { MockupCrop } from '../MockupCrop';
import { Accent, SectionHeading } from './SectionHeading';
import { experienceSteps, galleryPages } from '../../data/content';
import { devicesArea } from '../../data/images';

/** Section 12 — how it is used in a real class. */
export function ExperienceSection() {
  const worksheet = galleryPages[galleryPages.length - 1];
  return <section aria-labelledby="experience-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-72" data-mp="3ko9whizp4qak">
      <div className="mx-auto max-w-6xl" data-id="element-73" data-mp="3fxth3tcbeulk">
        <SectionHeading id="experience-heading" title={<>
              Open It. Choose What You Need. <Accent data-id="element-75" data-mp="3awclac8otybu">Use It in Your Next Class.</Accent>
            </>} data-id="element-74" data-mp="3fwrxh0h8gzs8" />

        <div className="mt-14 grid items-center gap-12 lg:grid-cols-[1.15fr_1fr] lg:gap-16" data-id="element-76" data-mp="3616vv3g2u1j0">
          <div className="relative pb-10 pr-6 sm:pr-10" data-id="element-77" data-mp="30zhkfmoxzlue">
            <MockupCrop crop={devicesArea} alt="Makeup Instructor Ready open on a tablet and a laptop" className="rounded-[20px] shadow-[0_40px_80px_-40px_rgba(59,27,87,0.5)]" data-id="element-78" data-mp="2wyfj90bgszps" />
            <img src={worksheet.src} alt={`Printed worksheet — ${worksheet.title}`} width={960} height={1200} loading="lazy" decoding="async" className="absolute bottom-0 right-0 w-[32%] rotate-[3deg] rounded-[6px] border border-brand-charcoal/10 bg-white shadow-[0_24px_40px_-20px_rgba(34,30,36,0.45)]" data-id="element-79" data-mp="3oxt0wrlbc19l" />
          </div>

          <ol className="border-t border-brand-charcoal/12" data-id="element-80" data-mp="bnc3ayyb4xnz">
            {experienceSteps.map(step => <li key={step.number} className="flex items-start gap-5 border-b border-brand-charcoal/12 py-5" data-id="element-81" data-mp="1rijcui9e1w6">
                <span className="w-10 flex-none font-display text-[1.8rem] font-bold leading-none text-brand-plum" data-id="element-82" data-mp="2ifmpzzhdhxl0">
                  {step.number}
                </span>
                <div data-id="element-83" data-mp="2mfeqdowm4xfa">
                  <p className="font-body text-[13px] font-semibold uppercase tracking-[0.12em] text-brand-charcoal" data-id="element-84" data-mp="syr5g44w3hta">
                    {step.title}
                  </p>
                  <p className="mt-1 text-[15px] leading-relaxed text-brand-charcoal/65" data-id="element-85" data-mp="o2a6eew5jj1f">{step.description}</p>
                </div>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}